export default {
  breakfast: "Breakfast",
  snackAfterBreakfast: "Snack After Breakfast",
  lunch: "Lunch",
  snackAfterLunch: "Snack After Lunch",
  dinner: "Dinner",
  snackAfterDinner: "Snack After Dinner",
};
